import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { transition, trigger, useAnimation } from '@angular/animations';

import { AlarmLocationModel } from './alarm-store/alarm.actions';

import { pulseUpdate } from '../../../shared/animations/pulse.animation';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'era-alarm-ui',
  templateUrl: './alarm.component.html',
  styleUrls: ['./alarm.component.scss'],
  animations: [trigger('pulse', [transition('* => *', [useAnimation(pulseUpdate)])])],
})
export class AlarmComponent {
  readonly alarm = input.required<AlarmLocationModel>();
}
